import React from 'react';

export const LoadingButton = ({ 
  loading, 
  disabled, 
  children, 
  loadingText, 
  className = '', 
  ...props 
}) => {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={`${className} ${loading ? 'loading' : ''}`}
    >
      {loading && (
        <span className="button-spinner" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <circle 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="31.4 31.4"
              strokeDashoffset="0"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 12 12"
                to="360 12 12"
                dur="1s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </span>
      )}
      <span className={loading ? 'button-text-loading' : ''}>
        {loading && loadingText ? loadingText : children}
      </span>
    </button>
  );
};

export const SkeletonLoader = ({ className = '', width, height, count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          className={`skeleton ${className}`}
          style={{ width, height }}
          aria-label="Loading..."
        />
      ))}
    </>
  );
};

export const ContentCardSkeleton = () => {
  return (
    <div className="content-card skeleton-card">
      <SkeletonLoader height="200px" className="skeleton-image" />
      <div className="skeleton-content">
        <SkeletonLoader height="24px" width="70%" />
        <SkeletonLoader height="16px" width="100%" count={3} />
        <div className="skeleton-footer">
          <SkeletonLoader height="16px" width="30%" />
          <SkeletonLoader height="16px" width="40%" />
        </div>
      </div>
    </div>
  );
};

export const ActivityCardSkeleton = () => {
  return (
    <div className="activity-card skeleton-card">
      <div className="skeleton-header">
        <SkeletonLoader height="40px" width="40px" className="skeleton-avatar" />
        <div className="skeleton-user-info">
          <SkeletonLoader height="16px" width="150px" />
          <SkeletonLoader height="14px" width="100px" />
        </div>
      </div>
      <SkeletonLoader height="20px" width="80%" />
      <SkeletonLoader height="16px" width="100%" count={2} />
      <div className="skeleton-footer">
        <SkeletonLoader height="32px" width="80px" />
        <SkeletonLoader height="32px" width="80px" />
      </div>
    </div>
  );
};

export const ProfileSkeleton = () => {
  return (
    <div className="profile-skeleton">
      <div className="skeleton-profile-header">
        <SkeletonLoader height="100px" width="100px" className="skeleton-avatar" />
        <div className="skeleton-profile-info">
          <SkeletonLoader height="28px" width="200px" />
          <SkeletonLoader height="16px" width="150px" />
          <SkeletonLoader height="40px" width="120px" />
        </div>
      </div>
      <SkeletonLoader height="100px" className="skeleton-bio" />
    </div>
  );
};

export const LoadingSpinner = ({ size = 'medium', message }) => {
  const sizeClass = `spinner-${size}`;
  
  return (
    <div className="loading-spinner-container" role="status">
      <div className={`loading-spinner ${sizeClass}`}>
        <svg viewBox="0 0 50 50">
          <circle 
            cx="25" 
            cy="25" 
            r="20" 
            fill="none"
            strokeWidth="4"
          />
        </svg>
      </div>
      {message && <p className="loading-message">{message}</p>}
      <span className="sr-only">Loading...</span>
    </div>
  );
};
